module.exports = __webpack_public_path__ + "img-dashboard/register/interaction.89702679.png";